<template>
  <div class="side-toolbar">
    <div class="segway-side-toolbar">
      <div class="option-box" id="option-id">
        <div class="option-con" v-show="isShowChatIcon">
          <img
            src="../../assets/images/icon-service.png"
            class="op-img"
            :alt="$t('support.hotline_service')" />
        </div>
        <div class="service-box">
          <!-- 亚太通用没有电话 -->
          <div class="service-phone" v-if="environmentData.country !== 'ap'">
            <div class="service-phone-top">
              <svg-icon name="ic_phone" class="svg"></svg-icon>
              <div class="name">{{ $t('support.hotline_service') }}</div>
            </div>
            <div class="service-phone-mid">
              <div class="desc">{{ onlineChat.phoneDesc }}</div>
            </div>
            <div v-if="customizeTime()" class="service-phone-bot">
              {{ $t(onlineChat.workTime) }}
            </div>
            <div v-else class="service-phone-bot">
              {{ $t('support.monday_friday') }}
            </div>
          </div>
          <div class="service-email">
            <div class="service-email-con">
              <svg-icon name="ic_email" class="svg"></svg-icon>
              <div class="name">{{ $t('support.official_email') }}</div>
            </div>
            <div
              v-if="environmentData.country === 'eu'"
              class="email desc"
              @click="openEmailModal()">
              {{ $t('support.service_view_info') }}
            </div>
            <div v-else class="email desc" @click="mailTo(onlineChat.email)">
              {{ onlineChat.email }}
            </div>
          </div>
          <!-- 亚太/澳洲/土耳其/俄罗斯客服标题和按钮 -->
          <BaseButton
            class="online-btn"
            style="padding: 8px 40px"
            v-if="environmentData.country !== 'ru'"
            @click="jumpToOnlineChat"
            >{{
              isAsia()
                ? $t('support.online_chat_asia')
                : $t('support.online_chat')
            }}</BaseButton
          >
        </div>
      </div>
    </div>
    <div class="backup-box" v-show="backTopFlag" @click="backup">
      <img src="../../assets/images/icon-back-top.png" class="backtop-img" />
    </div>

    <!-- 邮箱弹窗 -->
    <div class="email-modal" v-if="showEmailModal">
      <div class="email-box">
        <div class="close-icon" @click="showEmailModal = false">
          <img src="../../assets/images/modal-close.png" alt="" />
        </div>
        <div class="title">{{ $t('support.service_view_info') }}</div>
        <div class="email-list">
          <div class="email-item email-simple" v-for="item in transformedData">
            <div class="email-simple-name">{{ item.name }}</div>
            <div
              v-for="(child, index) in item.emailList"
              :key="index"
              class="email-simple-val"
              @click="mailClick(item, child)">
              {{ child }}
            </div>
          </div>
        </div>
        <!-- <div class="email-list">
          <div v-for="item in transformedData" class="email-simple">
            <div class="email-simple-name">{{ item.name }}</div>
            <div class="email-simple-val" @click="mailClick(item)">
              {{ item.email }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { getEmailList } from '@support/api';
import {
  environmentData,
  showOnlineChat,
  openInNewTabWithParams,
  isAsia,
  customizeTime
} from '@support/utils';
import { useLocalData, useUrl } from '@support/json';
const { $sensorTrack } = useNuxtApp();

const { onlineChat } = useLocalData();
const { onlineServer } = useUrl();
const emits = defineEmits(['backup']);

defineProps({
  backTopFlag: { type: Boolean, default: false },
  isShowChatIcon: { type: Boolean, default: true }
});
const showEmailModal = ref(false);
const transformedData = ref([]);

onMounted(async () => {
  // 获取邮箱
  const res: any = await getEmailList();
  transformedData.value = res.data;

  document.getElementById('option-id')?.addEventListener('mouseover', () => {
    $sensorTrack('self_repair_common_click', {
      click_type: '悬浮在线客服'
    });
  });
});

// 添加计算属性判断当前页面是否是配件价格页面
const isAccessoryPricePage = computed(() => {
  const route = useRoute();
  // 检查路由路径是否包含accessoryPrices或者包扣accessoryPrices/search
  if (route.path.includes('/accessoryPrices')) {
    return 1;
  } else if (route.path.includes('/accessoryPrices/search')) {
    return 2;
  }
});

function backup() {
  $sensorTrack('self_repair_common_click', {
    click_type: '回到顶部'
  });
  if (isAccessoryPricePage) {
    $sensorTrack('click', {
      pg_id: isAccessoryPricePage.value === 1 ? 'svc_ftg' : 'svc_ftg_dpg',
      btn_nm: '返回顶部'
    });
  }
  emits('backup');
}
// 调起本地邮箱
function mailTo(email: string) {
  location.href = `mailto:${email}`;
}
function mailClick(data: any, email: string) {
  $sensorTrack('more_email_options_in_europe_click', {
    more_email_options_in_europe: email,
    more_email_options_country: data.name
  });
  mailTo(email);
}

// 打开弹窗
function openEmailModal() {
  showEmailModal.value = true;
  console.log('openEmailModal');

  $sensorTrack('more_email_options_in_europe_exposure');
}
function jumpToOnlineChat() {
  const flag = showOnlineChat();
  if (flag) {
    useWindowsOpen(onlineServer);
  } else {
    openInNewTabWithParams({
      path: '/onlineChat'
    });
  }
}
</script>
<style lang="scss" scoped>
.side-toolbar {
  position: relative;
}
.email-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  .email-box {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    padding: 32px 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    border-radius: 20px;
    background-color: #ffffff;
    .close-icon {
      position: absolute;
      top: 0;
      right: -52px;
      width: 32px;
      height: 32px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      font-weight: 500;
      font-size: 24px;
      color: #000000;
    }
    .email-list {
      display: flex;
      flex-wrap: wrap;
      overflow: auto;
      max-height: 500px;
    }

    .email-simple {
      width: 250px;
      margin-top: 20px;
      margin-right: 40px;

      .email-simple-name {
        color: rgba(0, 0, 0, 1);
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .email-simple-val {
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        // font-weight: 500;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
          color: #3475ff;
        }
      }
      &:nth-child(2n) {
        margin-right: unset;
      }
    }
  }
}

.segway-side-toolbar {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  bottom: 175px;
  right: 40px;
  // width: 342px;
  cursor: pointer;
  z-index: 100;
  .option-con {
    // margin-top: 216px;
    .op-img {
      width: 32px;
      height: 32px;
    }
  }
  .service-box {
    visibility: hidden;
    position: fixed;
    bottom: 180px;
    right: 90px;
    padding: 16px 16px 20px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 10px 10px;
    .svg {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .name {
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      color: #000000;
    }
    .desc {
      font-size: 16px;
      font-weight: 500;
      color: #157be1;
    }
    .service-phone {
      margin-bottom: 8px;
      padding-bottom: 8px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      .service-phone-top {
        display: flex;
        .name {
          margin-bottom: 8px;
        }
      }
      .service-phone-mid {
        line-height: 20px;
        .line {
          width: 2px;
          height: 14px;
          background-color: #000;
          margin: 0 2px;
        }
      }
      .service-phone-bot {
        font-size: 14px;
        font-weight: 500;
        opacity: 0.6;
        color: #000;
        white-space: break-spaces;
      }
    }
    .service-email {
      // margin-bottom: 16px;
      .service-email-con {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
      }
    }
  }
  .option-box {
    // height: 269px;
    &:hover {
      .service-box {
        visibility: visible;
      }
    }
  }
  .option-con {
    width: 50px;
    height: 50px;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 30px 30px 30px 30px;
  }

  .online-btn {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
}
.backup-box {
  cursor: pointer;
  position: fixed;
  bottom: 105px;
  right: 40px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .backtop-img {
    width: 32px;
    height: 32px;
  }
}
</style>
